class WLSProductRelated extends HTMLElement {
    constructor() {
        super();

        this.classes = {
            active: 'active',
            slider: 'swiper',
            list: 'wls-product-related__list-inner',
            item: 'swiper-slide',
            navigation: {
                prev: 'wls-product-related__prev',
                next: 'wls-product-related__next',
                pagination: 'wls-product-related__pagination'
            }
        };

        this.elements = {
            slider: this.querySelector(`.${this.classes.slider}`),
            list: this.querySelector(`.${this.classes.list}`),
            items: this.querySelectorAll(`.${this.classes.item}`),
            navigation: {
                prev: this.querySelector(`.${this.classes.navigation.prev}`),
                next: this.querySelector(`.${this.classes.navigation.next}`),
                pagination: this.querySelector(`.${this.classes.navigation.pagination}`)
            }
        };

        this.resizeHandler = this.handleResize.bind(this);
    }

    connectedCallback() {
        if (this.checkIfEmpty()) return;
        this.init();
        window.addEventListener('resize', this.resizeHandler);
    }

    checkIfEmpty() {
        const listInner = this.elements.list;
        console.log(listInner, 'listInner');
        
        if (!listInner || !listInner.children.length) {
            this.style.display = 'none';
            return true;
        }
        return false;
    }

    init() {
        if (!this.shouldInitialize()) return;
        this.initializeSwiper();
    }

    shouldInitialize() {
        if (!this.elements.slider || !this.elements.items.length) return false;

        const width = window.innerWidth;
        const slidesCount = this.elements.items.length;

        if (width < 768 && slidesCount <= 1) return false;
        if (width >= 768 && width < 1024 && slidesCount <= 2) return false; 
        if (width >= 1024 && width < 1280 && slidesCount <= 3) return false;
        if (width >= 1280 && slidesCount <= 4) return false;

        return true;
    }

    handleResize() {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = setTimeout(() => {
            const shouldInit = this.shouldInitialize();

            if (shouldInit && !this.swiper) {
                this.initializeSwiper();
            } else if (!shouldInit && this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }, 300);
    }

    initializeSwiper() {
        this.swiper = new Swiper(this.elements.slider, {
            slidesPerView: 1.145,
            spaceBetween: 24,
            watchOverflow: true,
            navigation: {
                prevEl: this.elements.navigation.prev,
                nextEl: this.elements.navigation.next,
            },
            pagination: {
                el: this.elements.navigation.pagination,
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 4,
                }
            }
        });
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy();
        }
        window.removeEventListener('resize', this.resizeHandler);
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
    }
}

if (!customElements.get('wls-product-related')) {
    customElements.define('wls-product-related', WLSProductRelated);
}